import type { HubTheme } from "../hub-theme.types";

export const fitupHubTheme: HubTheme = {
  wordmark: "FITUP",
  wordmarkLabel: "FitUP",
  pageBackground: "#FAFAFA",

  heroBg: "linear-gradient(135deg, #DE2826 0%, #C90C14 55%, #9B0F14 100%)",
  heroStripe: undefined,
  heroGlow:
    "radial-gradient(closest-side, rgba(255,255,255,0.28) 0%, rgba(255,255,255,0) 70%)",
  greetingText: "rgba(255,255,255,0.78)",
  nameText: "#FFFFFF",
  pillBg: "rgba(255,255,255,0.16)",
  pillBorder: "rgba(255,255,255,0.22)",
  pillText: "#FFFFFF",
  codeText: "rgba(255,255,255,0.82)",
  watermark: "rgba(255,255,255,0.08)",

  avatarRing: "rgba(255,255,255,0.95)",
  avatarInnerBg: "linear-gradient(135deg, #FFFFFF 0%, #FFE9E9 100%)",
  avatarText: "#C90C14",

  loyaltyStripBg: "rgba(255,255,255,0.12)",
  loyaltyStripBorder: "rgba(255,255,255,0.18)",
  loyaltyFill: "linear-gradient(90deg, #FFFFFF 0%, rgba(255,255,255,0.7) 100%)",
  loyaltyText: "#FFFFFF",
  loyaltyMuted: "rgba(255,255,255,0.8)",

  surface: "#FFFFFF",
  surface2: "#F5F5F5",
  tileBg: "#FFFFFF",
  fg: "#1C1B1C",
  fgSoft: "#4A4847",
  muted: "#8E8E8E",
  muted2: "#B8B8B8",
  border: "#E5E5E5",
  borderSoft: "#EEEEEE",

  brand: "#DE2826",
  brandSoft: "#FCE9E9",
  brandStrong: "#C90C14",
  cream: "#C90C14",
  gradient: "linear-gradient(135deg, #DE2826 0%, #C90C14 100%)",
  qrIconBg: "linear-gradient(135deg, #DE2826 0%, #C90C14 100%)",
  memStripe: "linear-gradient(180deg, #DE2826 0%, #C90C14 100%)",

  eyebrowRule: "#DE2826",
  eyebrowText: "#DE2826",
  metaText: "#C90C14",
  metaBg: "#FCE9E9",
  metaBorder: "transparent",

  danger: "#C9001A",
  dangerSoft: "#FCE7EA",
  star: "#FFB400",
  success: "#1B9A4A",
  successSoft: "#E8F8EE",
  warning: "#B95E00",
  warningSoft: "#FFF1DE",
  cardShadow: "0 2px 10px rgba(28,27,28,0.05)",
  ctaShadow: "0 6px 18px rgba(222,40,38,0.28)",
  heroShadow: "0 12px 30px -8px rgba(222,40,38,0.35)",
  heroBorder: "rgba(255,255,255,0.18)",
  avatarShadow:
    "0 8px 22px rgba(222,40,38,0.22), inset 0 1px 0 rgba(255,255,255,0.45)",

  activityIcons: [
    {
      bg: "linear-gradient(135deg, #DE2826 0%, #C90C14 100%)",
      color: "#fff",
      shadow: "0 4px 10px rgba(222,40,38,0.28)",
    },
    {
      bg: "linear-gradient(135deg, #FFE0E0 0%, #FCE9E9 100%)",
      color: "#C90C14",
    },
    { bg: "#FCE9E9", color: "#DE2826" },
    { bg: "#F5F5F5", color: "#C90C14" },
  ],
};
